import Instance from "../../../../Axios";

// New Actions for the app

const GetCredViaturasById = (viaturasId) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/viaturas/${viaturasId}`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_VIATURAS_BY_ID",
        payload: data.yData[0],
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredViaturasById;